import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditName = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.03758 18.8833L4.04576 18.8588L4.05137 18.8336L5.00475 14.5488L5.00766 14.5358L5.00987 14.5225C5.08499 14.0724 5.31085 13.6872 5.63272 13.3658L14.0225 4.98662C15.3527 3.65811 17.4199 3.65811 18.7502 4.98662L19.5129 5.74836C20.1847 6.41938 20.5103 7.24549 20.5103 8.06067C20.5103 8.88897 20.1756 9.80632 19.5129 10.4682L11.1231 18.8473C10.8012 19.1688 10.4154 19.3945 9.96422 19.4696L9.95104 19.4718L9.93799 19.4747L5.64775 20.4269L5.50571 20.4584L5.45584 20.5082C5.45055 20.5086 5.44477 20.509 5.43846 20.5093C5.41839 20.5102 5.39903 20.5103 5.37473 20.5103C5.03462 20.5103 4.68385 20.3753 4.39332 20.0852C4.02704 19.7194 3.91685 19.2451 4.03758 18.8833ZM5.58319 19.4977L9.63599 18.5564C9.94212 18.537 10.2589 18.3835 10.4477 18.0787L18.7894 9.7475C19.2616 9.2759 19.5081 8.67375 19.5081 8.06067C19.5081 7.4476 19.2616 6.84545 18.7894 6.37385L17.9314 5.51689C17.5407 5.12673 16.9316 4.89458 16.3387 4.89458C15.7254 4.89458 15.1228 5.14053 14.6506 5.61211L6.30879 13.9433C6.00385 14.1317 5.84971 14.4482 5.83024 14.7546L4.88776 18.8021L4.87473 18.858V18.9155C4.87473 18.9165 4.87473 18.9178 4.87472 18.9194C4.87465 18.9359 4.87445 18.9823 4.87929 19.0258C4.88419 19.0698 4.90331 19.2227 5.03333 19.3526C5.16321 19.4823 5.31599 19.5013 5.35981 19.5061C5.40324 19.511 5.44959 19.5108 5.46617 19.5107C5.46775 19.5107 5.46906 19.5107 5.47007 19.5107H5.52738L5.58319 19.4977Z",
		fill: "white",
		stroke: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.7158 6.82275L17.6466 11.6526",
		stroke: "white",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})]
});
const ForwardRef = forwardRef(SvgEditName);
export default ForwardRef;
